import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  isAuthenticated: boolean
  currentUserId: string | null
  login: (pin: string) => boolean
  logout: () => void
  setCurrentUser: (userId: string) => void
}

const APP_PIN = import.meta.env.VITE_APP_PIN || '1234'

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      currentUserId: null,
      login: (pin: string) => {
        const isValid = pin === APP_PIN
        if (isValid) {
          set({ isAuthenticated: true })
        }
        return isValid
      },
      logout: () => set({ isAuthenticated: false, currentUserId: null }),
      setCurrentUser: (userId: string) => set({ currentUserId: userId }),
    }),
    {
      name: 'auth-storage',
    }
  )
)
